// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ApBa","col":"styles_col__24xyu"};